import {
	EVENT_ACTION_RETRIEVE_BOOKING_AS_GUEST_ERROR,
	EVENT_CATEGORY_PARKING_BOOKING,
	trackCustomEvent,
} from '../../../../../../shared/analytics';

export function trackGuestBookingError(message: string) {
	trackCustomEvent({
		category: EVENT_CATEGORY_PARKING_BOOKING,
		action: EVENT_ACTION_RETRIEVE_BOOKING_AS_GUEST_ERROR,
		label: message,
	});
}
